import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "@/redux/action";
import Utils from "@/utils";
import ProcessRender from "./children/ProcessRender";
import ProcessSquareRender from "./children/ProcessSquareRender";


class Process extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }

  }
  cancelProcess = () => {
    console.log("取消pros")
    this.props.onCancelProgressChange(true)
    if (this.props.currFile && this.props.fileToBlobStatus && this.props.uploading) {
      this.props.onSubmittingChange(false);
      return false;
    }
    this.props.onSubmittingChange(false);
    this.props.onUploadingChange(false);
    this.props.onUploadPercentChange(0);
    this.props.onProcessPercentChange(0);
    this.props.onUploadXHRChange(null);
    const xhr = this.props.uploadXHR;
    if (xhr && (this.props.isPicRemoveBg || this.props.uploadPercent < (this.props.uploadNumber ? this.props.uploadNumber * 100 : 100))) {
      xhr.abort();
    } else {
      if (this.props.fetchAbort) {
        this.props.fetchAbort();
      }
      Utils.cancleProgress();
    }
    if (this.props.cancelProcessCallBack) {
      this.props.cancelProcessCallBack();
    }
  };

  render() {
    return (
      this.props.visible
        ? this.props.visible
        : this.props.currFile && !this.props.crop
        ? this.props.submitting && (this.props.uploadPercent > 0 || this.props.processPercent > 0)
        : !this.props.fileToBlobStatus && (this.props.uploadPercent > 0 || this.props.processPercent > 0)
    ) ? (
      this.props.type === "square" ? (
        <ProcessSquareRender
          cancelProcess={this.cancelProcess}
          uploadPercent={this.props.uploadPercent}
          processPercent={this.props.processPercent}
          processStep={this.props.processStep}
          hideCancelText={this.props.hideCancelText}
          showProcessText={this.props.showProcessText}
          processText={this.props.processText}
          theme={this.props.theme}
          border={this.props.border}
          hideCancelBtn={this.props.hideCancelBtn}
        />
      ) : (
        <ProcessRender
          cancelProcess={this.cancelProcess}
          uploadPercent={this.props.uploadPercent}
          processPercent={this.props.processPercent}
          processStep={this.props.processStep}
          hideCancelText={this.props.hideCancelText}
          showProcessText={this.props.showProcessText}
          processText={this.props.processText}
          theme={this.props.theme}
          border={this.props.border}
          hideCancelBtn={this.props.hideCancelBtn}
        />
      )
    ) : null;
  }
}

const mapStateToPropos = state => ({
  processPercent: state.work.processPercent,
  processStep: state.work.processStep,
  currFile: state.files.currFile,
  fileToBlobStatus: state.work.fileToBlobStatus,
  uploading: state.work.uploading,
  uploadPercent: state.work.uploadPercent,
  submitting: state.work.submitting,
  uploadXHR: state.work.uploadXHR,
  fetchAbort: state.work.fetchAbort,
  crop: state.work.crop,
});
const mapDispatchToProps = dispatch => ({
  onProcessStepChange: processStep => dispatch(actions.onProcessStepChange(processStep)),
  onUploadXHRChange: uploadXHR => dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessPercentChange: processPercent => dispatch(actions.onProcessPercentChange(processPercent)),
  onUploadingChange: uploading => dispatch(actions.onUploadingChange(uploading)),
  onUploadPercentChange: uploadPercent => dispatch(actions.onUploadPercentChange(uploadPercent)),
  onSubmittingChange: submitting => dispatch(actions.onSubmittingChange(submitting)),
  onCancelProgressChange: submitting => dispatch(actions.onCancelProgressChange(submitting)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(Process);
